var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12048_18964)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12048_18964",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.16288 32 0 24.8371 0 16C0 7.16288 7.16288 0 16 0C24.8371 0 32 7.16288 32 16C32 24.8371 24.8371 32 16 32Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12048_18964)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L-6.63086 15.8605L-6.61038 15.0285L15.9995 16Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L-6.61426 15.1667L-6.5797 14.473L15.9995 16Z",
    fill: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L-6.58691 14.6125L-6.53571 13.92L16 16Z",
    fill: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L-6.5459 14.0583L-6.47806 13.3671L16 16Z",
    fill: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L-6.49121 13.5053L-6.40673 12.8167L15.9997 16Z",
    fill: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16.0001L-6.42383 12.9549L-6.32271 12.2676L15.9992 16.0001Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L-6.3418 12.4045L-6.22404 11.721L15.9993 16Z",
    fill: "#F8FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L-6.24707 11.858L-6.11267 11.177L15.9993 16Z",
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L-6.13965 11.314L-5.98733 10.6356L15.9992 16Z",
    fill: "#F6F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L-6.01758 10.7712L-5.84862 10.098L15.9997 16Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L-5.88184 10.2324L-5.69752 9.56293L15.9998 16Z",
    fill: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L-5.73438 9.69728L-5.53214 9.03296L16 16Z",
    fill: "#F3F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L-5.57324 9.1661L-5.35436 8.5069L15.9999 16Z",
    fill: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L-5.39941 8.63876L-5.16517 7.98468L15.9996 16Z",
    fill: "#F1F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L-5.21094 8.11521L-4.96134 7.46753L15.9999 16Z",
    fill: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L-5.01172 7.59685L-4.74676 6.95557L15.9995 16Z",
    fill: "#EFF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L-4.79883 7.08355L-4.51723 6.44995L15.9999 16Z",
    fill: "#EEF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L-4.57422 6.57666L-4.27726 5.94946L15.9992 16Z",
    fill: "#EDF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L-4.33691 6.0749L-4.02459 5.4541L15.9997 16Z",
    fill: "#ECF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9991 16L-4.08789 5.57827L-3.76021 4.96643L15.9991 16Z",
    fill: "#EBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 16L-3.8252 5.08933L-3.48344 4.48389L15.9994 16Z",
    fill: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L-3.55078 4.60545L-3.19366 4.01025L15.9999 16Z",
    fill: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L-3.26562 4.12933L-2.89443 3.54181L15.9997 16Z",
    fill: "#E8EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L-2.96875 3.65956L-2.58219 3.08228L15.9996 16Z",
    fill: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L-2.66016 3.19747L-2.2608 2.63043L15.9997 16Z",
    fill: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L-2.33984 2.74436L-1.9264 2.18628L16 16Z",
    fill: "#E5EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16.0001L-2.00977 2.29766L-1.58225 1.74982L15.9998 16.0001Z",
    fill: "#E4EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L-1.66797 1.85987L-1.22765 1.32355L15.9999 16Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9991 16L-1.31543 1.43105L-0.86231 0.904968L15.9991 16Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L-0.953125 1.00992L-0.487205 0.495361L15.9992 16Z",
    fill: "#E1EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L-0.580078 0.599048L-0.101358 0.0960083L15.9998 16Z",
    fill: "#E0EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L-0.197266 0.197147L0.294254 -0.294373L15.9999 16Z",
    fill: "#DFE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L0.196289 -0.197121L0.698049 -0.674561L15.9992 16Z",
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L0.598633 -0.579795L1.11319 -1.04572L15.9996 16Z",
    fill: "#DDE8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L1.00977 -0.952275L1.53585 -1.4054L15.9998 16Z",
    fill: "#DCE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16.0001L1.43066 -1.3145L1.96698 -1.75482L15.9996 16.0001Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L1.85938 -1.66782L2.40722 -2.09406L15.9995 16Z",
    fill: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L2.29688 -2.00959L2.85496 -2.42303L15.9993 16Z",
    fill: "#D9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L2.74414 -2.33984L3.31118 -2.7392L15.9998 16Z",
    fill: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L3.19727 -2.65983L3.77455 -3.0451L15.9998 16Z",
    fill: "#D7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L3.65918 -2.96828L4.2467 -3.33948L15.9997 16Z",
    fill: "#D6E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L4.12891 -3.26526L4.72411 -3.62238L15.9996 16Z",
    fill: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L4.60547 -3.5507L5.20963 -3.89246L16 16Z",
    fill: "#D4E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L5.08887 -3.8246L5.70071 -4.15228L15.9996 16Z",
    fill: "#D3E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L5.57812 -4.08703L6.19893 -4.39807L15.9999 16Z",
    fill: "#D2E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16.0001L6.07422 -4.33658L6.70142 -4.63226L15.9993 16.0001Z",
    fill: "#D1E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16.0001L6.57617 -4.57338L7.21105 -4.85498L15.9995 16.0001Z",
    fill: "#D0DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L7.08301 -4.7987L7.72557 -5.06494L15.9995 16Z",
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16.0001L7.59668 -5.01114L8.24564 -5.26074L15.9999 16.0001Z",
    fill: "#CEDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9991 16.0001L8.11426 -5.21083L8.76834 -5.44507L15.9991 16.0001Z",
    fill: "#CDDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L8.63867 -5.39904L9.29787 -5.61536L16 16Z",
    fill: "#CCDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L9.16602 -5.57309L9.83034 -5.77405L15.9999 16Z",
    fill: "#CBDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L9.69727 -5.73438L10.3667 -5.9187L16 16Z",
    fill: "#CADBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9991 16L10.2314 -5.88158L10.9047 -6.05054L15.9991 16Z",
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L10.7705 -6.01723L11.4476 -6.16827L15.9993 16Z",
    fill: "#C8DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L11.3135 -6.13885L11.9932 -6.27325L15.9996 16Z",
    fill: "#C7D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L11.8574 -6.24638L12.5409 -6.36542L15.9995 16Z",
    fill: "#C6D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L12.4043 -6.34108L13.0917 -6.44348L15.9998 16Z",
    fill: "#C5D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L12.9541 -6.42303L13.6427 -6.50751L15.9992 16Z",
    fill: "#C4D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L13.5049 -6.49088L14.1961 -6.55872L15.9996 16Z",
    fill: "#C3D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 16L14.0576 -6.54591L14.7501 -6.59711L15.9994 16Z",
    fill: "#C2D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L14.6123 -6.58684L15.3061 -6.62012L15.9998 16Z",
    fill: "#C1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L15.166 -6.61373L15.8598 -6.63037L15.9993 16Z",
    fill: "#C0D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 16L15.7217 -6.62781H16.4154L15.9994 16Z",
    fill: "#BFD4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L16.2778 -6.62781L16.9715 -6.60989L16 16Z",
    fill: "#BED3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L16.8333 -6.61371L17.5258 -6.57915L16 16.0001Z",
    fill: "#BDD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L17.3875 -6.58685L18.08 -6.53565L16 16Z",
    fill: "#BCD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L17.9418 -6.5459L18.633 -6.47806L16 16Z",
    fill: "#BBD1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L18.4934 -6.49084L19.1834 -6.40636L16 16Z",
    fill: "#BAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L19.0451 -6.42303L19.7325 -6.32191L16 16Z",
    fill: "#B9D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L19.5942 -6.34106L20.279 -6.2233L16 16.0001Z",
    fill: "#B8CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L20.1421 -6.2464L20.823 -6.112L16 16Z",
    fill: "#B7CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L20.6861 -6.13885L21.3645 -5.98654L16 16Z",
    fill: "#B6CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L21.2288 -6.01727L21.9021 -5.84831L16 16Z",
    fill: "#B5CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L21.7677 -5.88159L22.4358 -5.69727L16 16Z",
    fill: "#B4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L22.3027 -5.73438L22.967 -5.53214L16 16Z",
    fill: "#B3CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L22.8339 -5.57312L23.4931 -5.35424L16 16Z",
    fill: "#B2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L23.3613 -5.39899L24.0154 -5.16475L16 16.0001Z",
    fill: "#B1CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L23.8848 -5.21088L24.5325 -4.96128L16 16Z",
    fill: "#B0C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L24.4019 -5.01117L25.0445 -4.74621L16 16Z",
    fill: "#AFC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L24.9152 -4.79871L25.5501 -4.51711L16 16Z",
    fill: "#AEC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L25.4234 -4.57343L26.0506 -4.27647L16 16Z",
    fill: "#ADC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L25.9251 -4.33661L26.5459 -4.02429L16 16Z",
    fill: "#ACC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L26.4218 -4.08704L27.0336 -3.75936L16 16Z",
    fill: "#ABC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L26.9107 -3.82458L27.5162 -3.48283L16 16.0001Z",
    fill: "#AAC5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L27.3946 -3.55072L27.9898 -3.1936L16 16Z",
    fill: "#A9C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L27.8707 -3.26526L28.457 -2.89406L16 16Z",
    fill: "#A8C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L28.3405 -2.96826L28.9178 -2.5817L16 16.0001Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L28.8026 -2.65979L29.3696 -2.26043L16 16.0001Z",
    fill: "#A6C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L29.2557 -2.33978L29.8138 -1.92634L16 16.0001Z",
    fill: "#A5C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L29.7024 -2.00958L30.249 -1.58206L16 16Z",
    fill: "#A4C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L30.1402 -1.66779L30.6765 -1.22747L16 16.0001Z",
    fill: "#A3C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L30.569 -1.31451L31.095 -0.861394L16 16Z",
    fill: "#A2C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L30.9901 -0.952271L31.5046 -0.486351L16 16Z",
    fill: "#A1BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L31.401 -0.579834L31.904 -0.101114L16 16Z",
    fill: "#A0BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L31.8029 -0.197083L32.2944 0.294438L16 16Z",
    fill: "#9FBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L32.1958 0.197144L32.6746 0.698904L16 16Z",
    fill: "#9EBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L32.5798 0.59906L33.0458 1.11362L16 16Z",
    fill: "#9DBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L32.9523 1.00995L33.4054 1.53603L16 16Z",
    fill: "#9CBCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L33.3146 1.43109L33.7549 1.96741L16 16.0001Z",
    fill: "#9BBBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L33.6678 1.85986L34.0941 2.4077L16 16Z",
    fill: "#9ABAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.0096 2.29761L34.423 2.85569L16 16Z",
    fill: "#99BAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.3398 2.74432L34.7392 3.31136L16 16Z",
    fill: "#98B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.6598 3.19745L35.0451 3.77473L16 16Z",
    fill: "#97B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.9683 3.65955L35.3395 4.24707L16 16Z",
    fill: "#96B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L35.2653 4.12933L35.6224 4.72453L16 16.0001Z",
    fill: "#95B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L35.5507 4.60547L35.8925 5.20963L16 16Z",
    fill: "#94B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L35.8246 5.08929L36.151 5.70113L16 16Z",
    fill: "#93B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.0858 5.57825L36.3981 6.19905L16 16Z",
    fill: "#92B5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.3366 6.07489L36.6323 6.70209L16 16Z",
    fill: "#91B4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.5734 6.57666L36.855 7.21154L16 16Z",
    fill: "#90B4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.7987 7.08356L37.0637 7.72612L16 16Z",
    fill: "#8FB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.0112 7.5968L37.2608 8.24576L16 16Z",
    fill: "#8EB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.2109 8.11523L37.4451 8.76931L16 16Z",
    fill: "#8DB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.3978 8.63873L37.6154 9.29793L16 16Z",
    fill: "#8CB1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L37.5718 9.16614L37.7741 9.83046L16 16.0001Z",
    fill: "#8BB0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.7331 9.69733L37.9187 10.3668L16 16Z",
    fill: "#8AB0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.8816 10.2324L38.0506 10.9056L16 16Z",
    fill: "#89AFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.0173 10.7712L38.1683 11.4484L16 16Z",
    fill: "#88AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.1376 11.314L38.2733 11.9936L16 16Z",
    fill: "#87AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L38.2464 11.858L38.3654 12.5415L16 16.0001Z",
    fill: "#86ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.3411 12.4045L38.4435 13.0918L16 16Z",
    fill: "#85ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.423 12.9549L38.5075 13.6435L16 16Z",
    fill: "#84ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.4909 13.5053L38.5587 14.1965L16 16Z",
    fill: "#83ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.5459 14.0583L38.5971 14.7508L16 16Z",
    fill: "#82AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.5869 14.6125L38.6202 15.3062L16 16Z",
    fill: "#81AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.6138 15.1667L38.6304 15.8605L16 16Z",
    fill: "#80A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.6266 15.7223V16.416L16 16Z",
    fill: "#7FA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.6266 16.2778L38.6099 16.9715L16 16Z",
    fill: "#7EA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.6138 16.8333L38.5792 17.5258L16 16Z",
    fill: "#7DA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.5869 17.3875L38.5357 18.08L16 16Z",
    fill: "#7CA6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.5459 17.9418L38.4781 18.633L16 16Z",
    fill: "#7BA5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.4909 18.4934L38.4064 19.1834L16 16Z",
    fill: "#7AA5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.423 19.0451L38.3206 19.7325L16 16Z",
    fill: "#79A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.3411 19.5942L38.2234 20.279L16 16Z",
    fill: "#78A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.2464 20.1421L38.1107 20.823L16 16Z",
    fill: "#77A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.1376 20.6861L37.9866 21.3645L16 16Z",
    fill: "#76A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.0173 21.2288L37.8483 21.9021L16 16Z",
    fill: "#75A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.8816 21.7677L37.6973 22.4358L16 16Z",
    fill: "#74A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.7331 22.3027L37.5322 22.967L16 16Z",
    fill: "#73A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.5718 22.8339L37.3542 23.4931L16 16Z",
    fill: "#729FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.3978 23.3613L37.1648 24.0154L16 16Z",
    fill: "#719FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.2109 23.8848L36.9613 24.5325L16 16Z",
    fill: "#709EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.0112 24.4019L36.745 25.0445L16 16Z",
    fill: "#6F9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.7987 24.9152L36.5171 25.5501L16 16Z",
    fill: "#6E9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.5734 25.4234L36.2765 26.0506L16 16Z",
    fill: "#6D9CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.3366 25.9251L36.0243 26.5459L16 16Z",
    fill: "#6C9BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.0858 26.4218L35.7594 27.0336L16 16Z",
    fill: "#6B9BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L35.8246 26.9107L35.4829 27.5162L16 16Z",
    fill: "#6A9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L35.5507 27.3946L35.1936 27.9898L16 16Z",
    fill: "#6999FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L35.2653 27.8707L34.8941 28.457L16 16Z",
    fill: "#6899FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.9683 28.3405L34.5818 28.9178L16 16Z",
    fill: "#6798FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.6598 28.8026L34.2605 29.3696L16 16Z",
    fill: "#6697FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.3398 29.2557L33.9264 29.8138L16 16Z",
    fill: "#6597FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.0096 29.7024L33.5821 30.249L16 16Z",
    fill: "#6496FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L33.6678 30.1402L33.2275 30.6765L16 16Z",
    fill: "#6395FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L33.3146 30.569L32.8614 31.095L16 16Z",
    fill: "#6294FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L32.9523 30.9901L32.4864 31.5046L16 16Z",
    fill: "#6194FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L32.5798 31.401L32.1011 31.904L16 16Z",
    fill: "#6093FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L32.1958 31.8029L31.7056 32.2944L16 16Z",
    fill: "#5F92FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L31.8029 32.1958L31.3011 32.6746L16 16Z",
    fill: "#5E92FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L31.401 32.5798L30.8864 33.0458L16 16Z",
    fill: "#5D91FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L30.9901 32.9523L30.464 33.4054L16 16Z",
    fill: "#5C90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L30.569 33.3146L30.0326 33.7549L16 16Z",
    fill: "#5B90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L30.1402 33.6678L29.5923 34.0941L16 16Z",
    fill: "#5A8FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L29.7024 34.0096L29.1443 34.423L16 16Z",
    fill: "#598EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L29.2557 34.3398L28.6886 34.7392L16 16Z",
    fill: "#588EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L28.8026 34.6598L28.224 35.0451L16 16Z",
    fill: "#578DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L28.3405 34.9683L27.753 35.3395L16 16Z",
    fill: "#568CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L27.8707 35.2653L27.2755 35.6224L16 16Z",
    fill: "#558CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L27.3946 35.5507L26.7904 35.8925L16 16Z",
    fill: "#548BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L26.9107 35.8246L26.2989 36.151L16 16Z",
    fill: "#538AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L26.4218 36.0858L25.801 36.3981L16 16Z",
    fill: "#528AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L25.9251 36.3366L25.2979 36.6323L16 16Z",
    fill: "#5189FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L25.4234 36.5734L24.7885 36.855L16 16Z",
    fill: "#5088FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L24.9152 36.7987L24.2739 37.0637L16 16Z",
    fill: "#4F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L24.4019 37.0112L23.7542 37.2608L16 16Z",
    fill: "#4E87FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L23.8848 37.2109L23.2307 37.4451L16 16Z",
    fill: "#4D86FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L23.3613 37.3978L22.7021 37.6154L16 16Z",
    fill: "#4C86FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L22.8339 37.5718L22.1696 37.7741L16 16Z",
    fill: "#4B85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L22.3027 37.7331L21.6333 37.9187L16 16Z",
    fill: "#4A84FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L21.7677 37.8816L21.0931 38.0506L16 16Z",
    fill: "#4984FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L21.2288 38.0173L20.5517 38.1683L16 16Z",
    fill: "#4883FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L20.6861 38.1376L20.0051 38.2733L16 16Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L20.1421 38.2464L19.4586 38.3654L16 16Z",
    fill: "#4681FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L19.5942 38.3411L18.9082 38.4435L16 16Z",
    fill: "#4581FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L19.0451 38.423L18.3565 38.5075L16 16Z",
    fill: "#4480FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L18.4934 38.4909L17.8035 38.5587L16 16Z",
    fill: "#437FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L17.9418 38.5459L17.2493 38.5971L16 16Z",
    fill: "#427FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L17.3875 38.5869L16.6938 38.6202L16 16Z",
    fill: "#417EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L16.8333 38.6138L16.1382 38.6304L16 16Z",
    fill: "#407DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L16.2771 38.6266H15.582L15.9993 16Z",
    fill: "#3F7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L15.7221 38.6266L15.0283 38.6099L15.9998 16Z",
    fill: "#3E7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L15.1664 38.6138L14.4727 38.5792L15.9997 16Z",
    fill: "#3D7BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L14.6124 38.5869L13.9199 38.5357L15.9999 16Z",
    fill: "#3C7BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L14.0574 38.5459L13.3662 38.4781L15.9992 16Z",
    fill: "#3B7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L13.505 38.4909L12.8164 38.4064L15.9998 16Z",
    fill: "#3A79FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9991 16L12.954 38.423L12.2666 38.3206L15.9991 16Z",
    fill: "#3979FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L12.4042 38.3411L11.7207 38.2234L15.9997 16Z",
    fill: "#3878FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L11.8577 38.2464L11.1768 38.1107L15.9998 16Z",
    fill: "#3777FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L11.3132 38.1376L10.6348 37.9866L15.9992 16Z",
    fill: "#3677FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L10.7709 38.0173L10.0977 37.8483L15.9997 16Z",
    fill: "#3576FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L10.2319 37.8816L9.5625 37.6973L15.9996 16Z",
    fill: "#3475FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L9.69655 37.7331L9.03223 37.5322L15.9993 16Z",
    fill: "#3375FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L9.16604 37.5718L8.50684 37.3542L16 16Z",
    fill: "#3274FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L8.63846 37.3978L7.98438 37.1648L15.9997 16Z",
    fill: "#3173FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L8.11448 37.2109L7.4668 36.9613L15.9993 16Z",
    fill: "#3073FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L7.59636 37.0112L6.95508 36.745L15.9996 16Z",
    fill: "#2F72FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L7.08282 36.7987L6.44922 36.5171L15.9993 16Z",
    fill: "#2E71FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L6.57642 36.5734L5.94922 36.2765L15.9998 16Z",
    fill: "#2D71FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L6.0749 36.3366L5.4541 36.0243L16 16Z",
    fill: "#2C70FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 16L5.57766 36.0858L4.96582 35.7594L15.9994 16Z",
    fill: "#2B6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L5.08884 35.8246L4.4834 35.4829L15.9996 16Z",
    fill: "#2A6EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L4.60497 35.5507L4.00977 35.1936L15.9995 16Z",
    fill: "#296EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L4.12854 35.2653L3.54102 34.8941L15.9993 16Z",
    fill: "#286DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L3.65931 34.9683L3.08203 34.5818L15.9998 16Z",
    fill: "#276CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L3.19692 34.6598L2.62988 34.2605L15.9995 16Z",
    fill: "#266CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L2.74363 34.3398L2.18555 33.9264L15.9993 16Z",
    fill: "#256BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L2.29686 34.0096L1.74902 33.5821L15.9993 16Z",
    fill: "#246AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L1.85956 33.6678L1.32324 33.2275L15.9997 16Z",
    fill: "#236AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16L1.43038 33.3146L0.904297 32.8614L15.9993 16Z",
    fill: "#2269FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L1.00968 32.9523L0.495117 32.4864L15.9998 16Z",
    fill: "#2168FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L0.598743 32.5798L0.0957031 32.1011L15.9997 16Z",
    fill: "#2068FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L0.196598 32.1958L-0.294922 31.7056L15.9995 16Z",
    fill: "#1F67FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L-0.197365 31.8029L-0.674805 31.3011L15.9998 16Z",
    fill: "#1E66FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L-0.579978 31.401L-1.0459 30.8864L15.9999 16Z",
    fill: "#1D66FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L-0.95313 30.9901L-1.40625 30.464L15.9992 16Z",
    fill: "#1C65FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L-1.31456 30.569L-1.75488 30.0326L16 16Z",
    fill: "#1B64FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 16L-1.66849 30.1402L-2.09473 29.5923L15.9994 16Z",
    fill: "#1A64FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L-2.01039 29.7024L-2.42383 29.1443L15.9992 16Z",
    fill: "#1963FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L-2.3399 29.2557L-2.73926 28.6886L15.9999 16Z",
    fill: "#1862FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L-2.66062 28.8026L-3.0459 28.224L15.9992 16Z",
    fill: "#1762FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L-2.96864 28.3405L-3.33984 27.753L15.9997 16Z",
    fill: "#1661FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 16L-3.26593 27.8707L-3.62305 27.2755L15.9994 16Z",
    fill: "#1560FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L-3.55082 27.3946L-3.89258 26.7904L15.9999 16Z",
    fill: "#1460FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L-3.82466 26.9107L-4.15234 26.2989L16 16Z",
    fill: "#135FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L-4.0874 26.4218L-4.39844 25.801L15.9996 16Z",
    fill: "#125EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L-4.33713 25.9251L-4.63281 25.2979L15.9995 16Z",
    fill: "#115EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L-4.57387 25.4234L-4.85547 24.7885L15.9996 16Z",
    fill: "#105DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L-4.79919 24.9152L-5.06543 24.2739L15.9995 16Z",
    fill: "#0F5CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9991 16L-5.01212 24.4019L-5.26172 23.7542L15.9991 16Z",
    fill: "#0E5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L-5.21107 23.8848L-5.44531 23.2307L15.9998 16Z",
    fill: "#0D5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9991 16L-5.39989 23.3613L-5.61621 22.7021L15.9991 16Z",
    fill: "#0C5AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L-5.57345 22.8339L-5.77441 22.1696L15.9997 16Z",
    fill: "#0B59FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L-5.73463 22.3027L-5.91895 21.6333L15.9998 16Z",
    fill: "#0A59FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L-5.88182 21.7677L-6.05078 21.0931L15.9998 16Z",
    fill: "#0958FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 16L-6.01791 21.2288L-6.16895 20.5517L15.9994 16Z",
    fill: "#0857FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L-6.13904 20.6861L-6.27344 20.0051L15.9998 16Z",
    fill: "#0757FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L-6.24717 20.1421L-6.36621 19.4586L15.9992 16Z",
    fill: "#0656FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L-6.34194 19.5942L-6.44434 18.9082L15.9992 16Z",
    fill: "#0555FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L-6.42333 19.0451L-6.50781 18.3565L15.9997 16Z",
    fill: "#0455FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9991 16L-6.49173 18.4934L-6.55957 17.8035L15.9991 16Z",
    fill: "#0354FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L-6.54646 17.9418L-6.59766 17.2493L15.9995 16Z",
    fill: "#0253FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9991 16L-6.58781 17.3875L-6.62109 16.6938L15.9991 16Z",
    fill: "#0153FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L-6.61422 16.8333L-6.63086 16.1382L15.9995 16Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16L-6.62793 16.2778V15.7223L15.9999 16Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12048_18964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.145dc1910b4c222317c2c3d3179b6b26.svg";
export { ForwardRef as ReactComponent };